function ClimbingFormGrade(props) {


    return (
        <option value={props.chosenGradeClimb}> {props.chosenGradeClimb}</option>
    )
}

export default ClimbingFormGrade;